import { render, staticRenderFns } from "./AddUserIns.vue?vue&type=template&id=c5f95762&scoped=true&"
import script from "./AddUserIns.vue?vue&type=script&lang=js&"
export * from "./AddUserIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f95762",
  null
  
)

export default component.exports